import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dropdownContainer: {
    position: 'relative',
    width: '200px',
    fontFamily: '"Inter", sans-serif',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 12px',
    backgroundColor: 'rgba(250, 250, 254, 1)', // Light background
    borderRadius: '4px',
    border: '1px solid rgba(233, 235, 245, 1)',
    cursor: 'pointer',
    userSelect: 'none',
    minHeight: '32px',
    boxSizing: 'border-box',
    '&:hover': {
      backgroundColor: 'rgba(245, 245, 250, 1)',
    },
  },
  headerText: {
    fontSize: '14px',
    fontWeight: 500,
    color: 'rgba(27, 42, 71, 1)',
    fontFamily: '"Inter", sans-serif',
    lineHeight: '16px',
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
  },
  selectedCountText: {
    fontSize: '12px',
    fontWeight: 500,
    color: 'rgba(63, 81, 181, 1)',
    fontFamily: '"Inter", sans-serif',
    lineHeight: '16px',
    marginRight: '4px',
  },
  chevronIcon: {
    color: 'rgba(120, 121, 142, 1)',
    fontSize: '20px',
  },
  dropdownContent: {
    position: 'absolute',
    top: '100%',
    left: 0,
    marginTop: '8px',
    width: '200px',
    backgroundColor: '#ffffff',
    borderRadius: '4px',
    border: '1px solid rgba(233, 235, 245, 1)',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
    zIndex: 1000,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  searchContainer: {
    padding: '8px',
    borderBottom: '1px solid rgba(233, 235, 245, 1)',
  },
  searchInput: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'rgba(250, 250, 254, 1)',
      borderRadius: '4px',
      '& fieldset': {
        border: '1px solid rgba(233, 235, 245, 1)',
      },
      '&:hover fieldset': {
        border: '1px solid rgba(233, 235, 245, 1)',
      },
      '&.Mui-focused fieldset': {
        border: '1px solid rgba(63, 81, 181, 1)',
      },
    },
  },
  searchInputRoot: {
    height: '32px',
    padding: '0 !important',
  },
  searchInputField: {
    padding: '8px 12px !important',
    fontSize: '12px',
    color: 'rgba(27, 42, 71, 1)',
    fontFamily: '"Inter", sans-serif',
    '&::placeholder': {
      color: 'rgba(120, 121, 142, 1)',
      opacity: 1,
    },
  },
  searchIcon: {
    color: 'rgba(120, 121, 142, 1)',
    fontSize: '18px',
  },
  optionsContainer: {
    maxHeight: '240px',
    overflowY: 'auto',
    padding: '8px 0',
    '&::-webkit-scrollbar': {
      width: '11px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(250, 250, 254, 1)',
      borderRadius: '2px',
      margin: '8px 0',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(198, 199, 209, 1)',
      borderRadius: '16px',
      minHeight: '32px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: 'rgba(120, 121, 142, 1)',
    },
  },
  optionItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px',
    cursor: 'pointer',
    minHeight: '32px',
    gap: '8px',
    '&:hover': {
      backgroundColor: 'rgba(250, 250, 254, 1)',
    },
  },
  checkbox: {
    padding: '4px',
    color: 'rgba(198, 199, 209, 1)',
    '&.Mui-checked': {
      color: 'rgba(63, 81, 181, 1)', // Blue color for checked state
    },
    '& .MuiSvgIcon-root': {
      fontSize: '18px',
    },
  },
  optionLabel: {
    fontSize: '12px',
    fontWeight: 500,
    color: 'rgba(27, 42, 71, 1)',
    fontFamily: '"Inter", sans-serif',
    marginLeft: '8px',
    lineHeight: '16px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
    minWidth: 0,
  },
  noResults: {
    padding: '16px',
    textAlign: 'center',
  },
  noResultsText: {
    fontSize: '12px',
    color: 'rgba(120, 121, 142, 1)',
    fontFamily: '"Inter", sans-serif',
  },
  clearButtonContainer: {
    padding: '8px',
    borderTop: '1px solid rgba(233, 235, 245, 1)',
  },
  clearButton: {
    width: '100%',
    height: '32px',
    fontSize: '12px',
    fontWeight: 500,
    color: 'rgba(63, 81, 181, 1)',
    fontFamily: '"Inter", sans-serif',
    textTransform: 'none',
    borderColor: 'rgba(63, 81, 181, 1)',
    borderRadius: '4px',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'rgba(237, 231, 246, 0.3)',
      borderColor: 'rgba(63, 81, 181, 1)',
    },
  },
  actionButtonsContainer: {
    padding: '8px',
    borderTop: '1px solid rgba(233, 235, 245, 1)',
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
  },
  cancelButton: {
    height: '32px',
    fontSize: '12px',
    fontWeight: 500,
    color: 'rgba(27, 42, 71, 1)',
    fontFamily: '"Inter", sans-serif',
    textTransform: 'none',
    borderColor: 'rgba(233, 235, 245, 1)',
    borderRadius: '4px',
    backgroundColor: 'transparent',
    minWidth: '60px',
    '&:hover': {
      backgroundColor: 'rgba(250, 250, 254, 1)',
      borderColor: 'rgba(198, 199, 209, 1)',
    },
  },
  okButton: {
    height: '32px',
    fontSize: '12px',
    fontWeight: 500,
    fontFamily: '"Inter", sans-serif',
    textTransform: 'none',
    borderRadius: '4px',
    backgroundColor: 'rgba(63, 81, 181, 1)',
    color: '#ffffff',
    minWidth: '60px',
    '&:hover': {
      backgroundColor: 'rgba(48, 63, 159, 1)',
    },
  },
}));

export default useStyles;

